export const TRACK_STATE_CHANGE = "TRACK_STATE_CHANGE";
export const NEW_TRACK_LOADING = "NEW_TRACK_LOADING";
export const NEW_TRACK_LOADED = "NEW_TRACK_LOADED";
export const LOAD_DEFAULT_TRACK = "LOAD_DEFAULT_TRACK";
export const TRACK_SAVE = "TRACK_SAVE";
export const NEW_TRACK_SAVE = "NEW_TRACK_SAVE";